import React, { FC } from "react"

import "./Section.scss"
import { SectionProps } from "./Section.types"

const Section: FC<SectionProps> = ({
    className,
    children,
    ...props
}: SectionProps) => {
    return (
        <section className={`zb-section ${className ?? ""}`} {...props}>
            {children}
        </section>
    )
}

export default Section
